import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectUserList = createSelector(
	(state: IStore) => state.userList,
	(userList) => userList
)
